import { withBreakpointObserver } from '@studiometa/js-toolkit';
import {
  Slider as SliderCore,
  SliderDrag,
  SliderProgress,
  SliderItem,
  SliderDots,
  SliderBtn,
} from '@studiometa/ui';

/**
 * Slider
 */
export default class Slider extends withBreakpointObserver(SliderCore) {
  /**
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Slider',
    components: {
      SliderDrag,
      SliderItem,
      SliderProgress,
      SliderDots,
      SliderBtn,
    },
  };
}
